import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./realestate.css";
import HeroFooter from "../../components/footer";
import ScrollToTop from "./scrolltop";

const categories = [
  "Contract Management",
  "Foreign Collaborations",
  "Joint Ventures",
  "Corporate Law",
  "Information Technology",
  "Business Ventures",
  "MSME",
  "Start-up India Initiatives",
  "Property and Real Estate"
];

// Map each category to a custom slug
const categoryMapping = {
  "Contract Management": "contract",
  "Foreign Collaborations": "foreign",
  "Joint Ventures": "joint",
  "Corporate Law": "corporate",
  "Information Technology": "information",
  "Business Ventures": "buisness",
  "MSME": "msme",
  "Start-up India Initiatives": "startup",
  "Property and Real Estate": "realestate"
};

const MSME = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const toggleSidebar = () => setSidebarOpen(prev => !prev);
  
  return (
    <div className="practice-page">
            <ScrollToTop/>
      <div className="mobile-menu-button" onClick={toggleSidebar}>
        <i className="fa fa-bars" aria-hidden="true"></i>
      </div>
      
      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <h2 className="sidebar-title">Our Offerings</h2>
        <ul className="category-list">
          {categories.map((category, index) => (
            <li key={index} className={category === "MSME" ? "active" : ""}>
              <Link
                onClick={() => setSidebarOpen(false)}
                to={`/${categoryMapping[category]}`}
              >
                {category}
              </Link>
            </li>
          ))}
        </ul>
      </aside>
      
      <main className="conten">
        <h2>MSME</h2>
        <p className="intro">
          InduratnaLaw is dedicated to providing specialized legal solutions for Micro, Small, and Medium Enterprises. Our practical advice and support help MSMEs navigate challenges and achieve sustainable growth.
        </p>
        <section className="details">
          <h3>Our Expertise</h3>
          <p>
            We understand the unique challenges MSMEs face—from regulatory hurdles to funding issues. Our team tailors solutions to safeguard your business interests while encouraging innovation.
          </p>
          <h3>Key Services</h3>
          <ul>
            <li>Regulatory Compliance and Licensing</li>
            <li>Contractual Negotiations and Drafting</li>
            <li>Financial and Tax Advisory</li>
            <li>Business Restructuring and Expansion Support</li>
            <li>Dispute Resolution for MSME Matters</li>
          </ul>
          <h3>Why Choose InduratnaLaw?</h3>
          <p>
            Our deep understanding of MSME challenges and a hands-on approach ensure that your enterprise is equipped with the legal tools for success.
          </p>
        </section>
      </main>
      <HeroFooter />
    </div>
  );
};

export default MSME;
